import { Component, Input } from '@angular/core';
import { getAppHref } from 'navigation/nav-shared/utils/link.utils';

@Component({
  selector: 'usr-tos-notice',
  templateUrl: './tos-notice.component.html',
  styleUrls: ['./tos-notice.component.scss'],
})
export class TosNoticeComponent {
  @Input() formType: string = 'sign-in';
  tosLink: string = getAppHref('/about-us/legal/terms-and-conditions');
  privacyLink: string = getAppHref('/about-us/legal/privacy-policy');
}
